var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "whatwg-fetch";
import { withRouter } from "react-router-dom";
import ReactIframeResizer from "react-iframe-resizer-super";
import localeMap from "../../constants/Locale";
var StaticContent = /** @class */ (function (_super) {
    __extends(StaticContent, _super);
    function StaticContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StaticContent.prototype.render = function () {
        var _a = this.props, fullUrl = _a.fullUrl, contentPath = _a.contentPath, languageId = _a.languageId, darkTheme = _a.darkTheme;
        var companyName = "gold-mob";
        var language = localeMap[languageId];
        var origin = window.location.origin;
        var srcUrl = fullUrl || "".concat(origin, "/iframes/").concat(companyName, "/").concat(contentPath, "/").concat(language, "?theme=").concat(darkTheme ? "dark" : "light");
        return (_jsx(ReactIframeResizer, __assign({ iframeResizerEnable: true, src: srcUrl, iframeResizerOptions: {
                checkOrigin: false,
                log: true,
                overflowY: 'auto',
                inPageLinks: true,
            }, style: {
                width: "100%",
                minHeight: 500,
            } }, { children: _jsxs("h1", { children: ["404 - ", srcUrl] }) })));
    };
    return StaticContent;
}(Component));
StaticContent.propTypes = {
    languageId: PropTypes.number.isRequired,
    darkTheme: PropTypes.bool,
    contentPath: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    openRegistrationModalAction: PropTypes.func.isRequired
};
var mapStateToProps = function (state) { return ({
    languageId: state.application.get("languageId"),
    darkTheme: state.application.get("darkTheme"),
    country: state.application.get("client").country
}); };
export default withRouter(connect(mapStateToProps)(StaticContent));



// WEBPACK FOOTER //
// ./src/components/staticContent/Iframes.jsx